import axios from 'axios';

export const postedNoteService = {
    getPostedNoteService: (clientId) => axios.get(`/client/${clientId}/posted-note`, { auth: true }),

    updatePostedNoteService: (clientId, body) => axios.patch(`/client/${clientId}/posted-note`, body, { auth: true }),
};
